import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { EnvironmentService } from './environment.service';
import DevExpress from 'devextreme';
import ODataStore from 'devextreme/data/odata/store';

@Injectable({
  providedIn: 'root'
})
export class DataServiceService {

  private merchantsDataSource: DataSource;
  private quickActionMerchantsDataSource: any;
  private pricelistStandardDataSource: any;
  private billingTypeDataSource: any;
  private serviceDataSource: any;
  private countryDataSource: any;
  private transactionDataSource: any;
  private bankDataSource: any;
  private ledgerTransactionsDataSource: any;

  

  private priceListTierType =
    [
      { Id: 0, Name: 'Count' },
      { Id: 1, Name: 'Amount' },
    ]

  private priceListCycle =
    [
      { Id: 0, Name: 'Monthly' },
      { Id: 1, Name: 'Weekly' },
    ]

  private priceListStatusType =
    [
      { Id: 0, Name: 'Active' },
      { Id: 1, Name: 'Inactive' },
    ]

  constructor(private environmentService: EnvironmentService) {

    this.pricelistStandardDataSource = {
      store: {
        type: 'odata',
        url: this.environmentService.getConfig('BackendApi') + 'odata/Pricelists',
        key: 'Id'
      }
    };

    this.billingTypeDataSource = {
      store: {
        type: 'odata',
        url: this.environmentService.getConfig('BackendApi') + 'odata/BillingTypes',
        key: 'Id'
      }
    };

    this.serviceDataSource = {
      store: {
        type: 'odata',
        url: this.environmentService.getConfig('BackendApi') + 'odata/Services',
        key: 'Id'
      }
    };

    this.bankDataSource = {
      store: {
        type: 'odata',
        url: this.environmentService.getConfig('BackendApi') + 'odata/Banks',
        key: 'Id'
      }
    };

    this.countryDataSource = {
      store: {
        type: 'odata',
        url: this.environmentService.getConfig('BackendApi') + 'odata/Countries',
        key: 'Id'
      }
    };

    this.transactionDataSource = {
      store: {
        type: 'odata',
        url: this.environmentService.getConfig('BackendApi') + 'odata/Transactions',
        key: 'Id'
      }
    };

    this.ledgerTransactionsDataSource = new DataSource({
      pageSize: 20,
      store: new ODataStore({
        url: `${this.environmentService.getConfig('BackendApi')}odata/LedgerTransactions`,
      })
    });

    this.merchantsDataSource = new DataSource({
      pageSize: 20,
      store: new ODataStore({
        url: `${this.environmentService.getConfig('BackendApi')}odata/MerchantsGrid`,
      })
    });

    this.quickActionMerchantsDataSource = new DataSource({
      key: 'Id',
      store: new ODataStore({
        url: `${this.environmentService.getConfig('BackendApi') }odata/QuickActionsMerchants`,
      })
    });

  }

  public getTransactionDataSource() {
    return this.transactionDataSource;
  }

  public getMerchantsDataSource() {
    return this.merchantsDataSource;
  }

  public getQuickActionsMerchantDataSource() {
    return this.quickActionMerchantsDataSource;
  }

  public getPricelistStandardDataSource() {
    return this.pricelistStandardDataSource;
  }

  public getBillingTypeDataSource() {
    return this.billingTypeDataSource;
  }

  public getServiceDataSource() {
    return this.serviceDataSource;
  }

  public getBankDataSource() {
    return this.bankDataSource;
  }

  public getCountryDataSource() {
    return this.countryDataSource;
  }

  public getPriceListType() {
    return this.priceListTierType;
  }

  public getPriceListCycle() {
    return this.priceListCycle;
  }

  public getPriceListStatusType() {
    return this.priceListStatusType;
  }

  public getLedgerTransactionsDataSource(){
    return this.ledgerTransactionsDataSource;
  }
}
